import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import SpotWorkCalendar from './components/SpotWorkCalendar';
import WhyTrial from './components/WhyTrial';
import SeniorStories from './components/SeniorStories';
import Philosophy from './components/Philosophy';
import Features from './components/Features';
import DayAtKirari from './components/DayAtKirari';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <SpotWorkCalendar />
      <WhyTrial />
      <SeniorStories />
      <Philosophy />
      <Features />
      <DayAtKirari />
    </div>
  );
}
